export default function urlToSearchParams(url: string): URLSearchParams {
  const parts = url.split('?')
  const queryString = parts.length > 1 ? parts[1] : url

  return new URLSearchParams(queryString)
}
